import Swal from "sweetalert2";
import { httpClient } from "../../utils/HttpClient";

import {
  GET_USER_FETCH,
  GET_USER_SUCCESS,
  GET_USER_REJECTED,
  GET_USERS_FETCH,
  GET_USERS_SUCCESS,
  GET_USERS_REJECTED,
  SAVE_USER_SUCCESS,
  SAVE_USER_REJECTED,
  GET_ROLES_FETCH,
  GET_ROLES_SUCCESS,
  GET_ROLES_REJECTED,
  GET_ROLE_FETCH,
  GET_ROLE_SUCCESS,
  GET_ROLE_REJECTED,
  SAVE_ROLE_SUCCESS,
  SAVE_ROLE_REJECTED,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_REJECTED,
  GET_PERMISSIONS_FETCH,
  GET_PERMISSIONS_SUCCESS,
  GET_PERMISSIONS_REJECTED,
  GET_PERMISSION_FETCH,
  GET_PERMISSION_SUCCESS,
  GET_PERMISSION_REJECTED,
  SAVE_PERMISSION_SUCCESS,
  SAVE_PERMISSION_REJECTED,
  DELETE_PERMISSION_SUCCESS,
  DELETE_PERMISSION_REJECTED,
  SAVE_ROLE_PERMISSION_SUCCESS,
  SAVE_ROLE_PERMISSION_REJECTED,
  GET_APPROVER_FETCH,
  GET_APPROVER_SUCCESS,
  GET_APPROVER_REJECTED,
  GET_DOA_ROLES_FETCH,
  GET_DOA_ROLES_SUCCESS,
  GET_DOA_ROLES_REJECTED,
  GET_APPROVERS_FETCH,
  GET_APPROVERS_SUCCESS,
  GET_APPROVERS_REJECTED,
  GET_ROLE_USER_FETCH,
  GET_ROLE_USER_SUCCESS,
  GET_ROLE_USER_REJECTED,
  GET_DOA_ROLE_USER_FETCH,
  GET_DOA_ROLE_USER_SUCCESS,
  GET_DOA_ROLE_USER_REJECTED,
  LIST_PR_FETCH,
  LIST_PR_SUCCESS,
  LIST_PR_REJECTED,
  LIST_USER_MANAGER_FETCH,
  LIST_USER_MANAGER_SUCCESS,
  LIST_USER_MANAGER_REJECTED,
  GET_CEOS_FETCH,
  GET_CEOS_SUCCESS,
  GET_CEOS_REJECTED,
} from "./../../Constants";

export const updateUserApprover = (id, value) => {
  return (dispatch) => {
    return httpClient
      .put(`/backoffice/user-approver/${id}`, value)
      .then((result) => {
        dispatch({
          type: SAVE_USER_SUCCESS,
          payload: "Updated the user has approver is successfully.",
        });

        dispatch(getAllUsers());
        Swal.fire({
          text: result.data.message,
          icon: "success",
        });
      })
      .catch((err) => {
        dispatch({ type: SAVE_USER_REJECTED });
      });
  };
};

export const getAllCEOs = () => {
  return (dispatch) => {
    dispatch({
      type: GET_CEOS_FETCH,
    });
    return httpClient
      .get(`/backoffice/ceos`)
      .then(({ data }) => {
        dispatch({
          type: GET_CEOS_SUCCESS,
          payload: data,
        });
      })
      .catch((err) => dispatch({ type: GET_CEOS_REJECTED }));
  };
};

export const getAllApprover = (perid) => {
  return (dispatch) => {
    dispatch({
      type: GET_APPROVER_FETCH,
    });
    return httpClient
      .get(`/backoffice/approver/${perid}`)
      .then(({ data }) => {
        dispatch({
          type: GET_APPROVER_SUCCESS,
          payload: data,
        });
      })
      .catch((err) => dispatch({ type: GET_APPROVERS_REJECTED }));
  };
};

export const getAllApprovers = () => {
  return (dispatch) => {
    dispatch({
      type: GET_APPROVERS_FETCH,
    });
    return httpClient
      .get(`/backoffice/approvers`)
      .then(({ data }) => {
        dispatch({
          type: GET_APPROVERS_SUCCESS,
          payload: data,
        });
      })
      .catch((err) => dispatch({ type: GET_APPROVERS_REJECTED }));
  };
};

export const getAllUsers = () => {
  return async (dispatch) => {
    dispatch({
      type: GET_USERS_FETCH,
    });
    try {
      const result = await httpClient.get(`/backoffice/users`);
      dispatch({
        type: GET_USERS_SUCCESS,
        payload: result.data,
      });
    } catch (err) {
      dispatch({ type: GET_USERS_REJECTED });
    }
  };
};

export const getAllUserProfiles = ({
  USER_ID,
  USER_NAME,
  DATA_UPDATE_STATUS,
  STATUS,
  DEPARTMENT,
}) => {
  return async (dispatch) => {
    dispatch({
      type: GET_USERS_FETCH,
    });
    try {
      const result = await httpClient.get(
        `/backoffice/user-profiles?userid=${USER_ID}&username=${USER_NAME}&updatestatus=${DATA_UPDATE_STATUS}&status=${STATUS}&department=${DEPARTMENT}`
      );
      dispatch({
        type: GET_USERS_SUCCESS,
        payload: result.data,
      });
    } catch (err) {
      dispatch({ type: GET_USERS_REJECTED });
    }
  };
};

export const getUserProfileByID = (id) => {
  return async (dispatch) => {
    dispatch({
      type: GET_USERS_FETCH,
    });
    try {
      const result = await httpClient.get(`/backoffice/user-profiles/${id}`);

      dispatch({
        type: GET_USER_SUCCESS,
        payload: result.data,
      });
    } catch (error) {
      dispatch({ type: GET_USER_REJECTED });
    }
  };
};

export const updateMultipleUserRole = (role_id, value) => {
  return async (dispatch) => {
    try {
      const result = await httpClient.put(
        `/backoffice/user-multiple/${role_id}`,
        value
      );
      dispatch({
        type: SAVE_USER_SUCCESS,
        payload: "Updated the user has role is successfully.",
      });

      dispatch(getAllUsers());
      Swal.fire({
        text: result.data.message,
        icon: "success",
      });
    } catch (err) {
      dispatch({ type: SAVE_USER_REJECTED });
    }
  };
};

export const updateUserRole = (id, value) => {
  return async (dispatch) => {
    try {
      const result = await httpClient.put(`/backoffice/user/${id}`, value);
      dispatch({
        type: SAVE_USER_SUCCESS,
        payload: "Updated the user has role is successfully.",
      });

      dispatch(getAllUsers());
      Swal.fire({
        text: result.data.message,
        icon: "success",
      });
    } catch (err) {
      dispatch({ type: SAVE_USER_REJECTED });
    }
  };
};

export const updateUserProfileRole = (id, value) => {
  return async (dispatch) => {
    try {
      const result = await httpClient.put(
        `/backoffice/update-role-profile/${id}`,
        { payload: value },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        }
      );
      dispatch({
        type: SAVE_USER_SUCCESS,
        payload: "Updated the user has role is successfully.",
      });

      // dispatch(getAllUsers());
      // Swal.fire({
      //   text: result.data.message,
      //   icon: "success",
      // });
    } catch (err) {
      dispatch({ type: SAVE_USER_REJECTED });
    }
  };
};

export const deleteRoleFormUser = (id, value) => {
  return async (dispatch) => {
    try {
      await httpClient.put(
        `/backoffice/delete-role-profile/${id}`,
        { payload: value },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        }
      );
      dispatch({
        type: SAVE_USER_SUCCESS,
        payload: "Delete the user has role is successfully.",
      });
    } catch (err) {
      dispatch({ type: SAVE_USER_REJECTED });
    }
  };
};

export const saveUserProfile = (id, value) => {
  return async (dispatch) => {
    try {
      await httpClient.put(`/backoffice/update-user-profile/${id}`, value);
      dispatch({
        type: SAVE_USER_SUCCESS,
        payload: "Save the user has role is successfully.",
      });

      Swal.fire({
        text: "Data Saved",
        icon: "success",
      });
    } catch (err) {
      dispatch({ type: SAVE_USER_REJECTED });
    }
  };
};

export const getAllRoleUserPR = (id) => {
  return async (dispatch) => {
    dispatch({
      type: GET_ROLE_USER_FETCH,
    });
    try {
      const result = await httpClient.get(
        `/backoffice/role-user?id=${id}&app=PRS001`
      );
      dispatch({
        type: GET_ROLE_USER_SUCCESS,
        payload: result.data,
      });
    } catch (err) {
      dispatch({ type: GET_ROLE_USER_REJECTED });
    }
  };
};

export const getAllRoleUserDOA = (id) => {
  return async (dispatch) => {
    dispatch({
      type: GET_DOA_ROLE_USER_FETCH,
    });
    try {
      const result = await httpClient.get(
        `/backoffice/role-user?id=${id}&app=DOA`
      );
      dispatch({
        type: GET_DOA_ROLE_USER_SUCCESS,
        payload: result.data,
      });
    } catch (err) {
      dispatch({ type: GET_DOA_ROLE_USER_REJECTED });
    }
  };
};

export const getAllRoles = () => {
  return async (dispatch) => {
    dispatch({
      type: GET_ROLES_FETCH,
    });
    try {
      const result = await httpClient.get(`/backoffice/roles`);
      dispatch({
        type: GET_ROLES_SUCCESS,
        payload: result.data,
      });
    } catch (err) {
      dispatch({ type: GET_ROLES_REJECTED });
    }
  };
};

export const getAllUserDepartments = () => {
  return (dispatch) => {
    dispatch({
      type: "GET_USER_DEPARTMENT_FETCH",
    });

    httpClient
      .get(`/backoffice/user-department`)
      .then(({ data }) => {
        dispatch({ type: "GET_USER_DEPARTMENT_SUCCESS", payload: data });
      })
      .catch(() => {
        dispatch({ type: "GET_USER_DEPARTMENT_REJECTED" });
      });
  };
};

export const getAllDOARoles = () => {
  return async (dispatch) => {
    dispatch({
      type: GET_DOA_ROLES_FETCH,
    });
    try {
      const result = await httpClient.get(`/backoffice/doa-roles`);
      dispatch({
        type: GET_DOA_ROLES_SUCCESS,
        payload: result.data,
      });
    } catch (err) {
      dispatch({ type: GET_DOA_ROLES_REJECTED });
    }
  };
};

export const getRolesById = (id) => {
  return async (dispatch) => {
    dispatch({
      type: GET_ROLE_FETCH,
    });
    try {
      const result = await httpClient.get(`/backoffice/roles/${id}`);
      dispatch({
        type: GET_ROLE_SUCCESS,
        payload: result.data,
      });
    } catch (err) {
      dispatch({ type: GET_ROLE_REJECTED });
    }
  };
};

export const addRole = (value) => {
  return async (dispatch) => {
    try {
      const result = await httpClient.post(`/backoffice/roles`, value);
      dispatch({
        type: SAVE_ROLE_SUCCESS,
        payload: result.data.message,
      });
      dispatch(getAllRoles());
      Swal.fire({
        text: result.data.message,
        icon: "success",
      });
    } catch (err) {
      dispatch({ type: SAVE_ROLE_REJECTED });
    }
  };
};

export const updateRole = (id, value, history) => {
  return async (dispatch) => {
    try {
      const result = await httpClient.put(`/backoffice/roles/${id}`, value);
      dispatch({
        type: SAVE_ROLE_SUCCESS,
        payload: result.data.message,
      });
      dispatch(getAllRoles());
      Swal.fire({
        text: result.data.message,
        icon: "success",
      }).then(() => {
        history.goBack();
      });
    } catch (err) {
      dispatch({ type: SAVE_ROLE_REJECTED });
    }
  };
};

export const deleteRole = (id) => {
  return async (dispatch) => {
    try {
      const result = await httpClient.delete(`/backoffice/roles/${id}`);
      dispatch({
        type: DELETE_ROLE_SUCCESS,
        payload: result.data.message,
      });
      dispatch(getAllRoles());
      Swal.fire({
        text: result.data.message,
        icon: "success",
      });
    } catch (err) {
      dispatch({ type: DELETE_ROLE_REJECTED });
    }
  };
};

export const getAllPermissions = () => {
  return async (dispatch) => {
    dispatch({
      type: GET_PERMISSIONS_FETCH,
    });
    try {
      const result = await httpClient.get(`/backoffice/permissions`);
      dispatch({
        type: GET_PERMISSIONS_SUCCESS,
        payload: result.data,
      });
    } catch (err) {
      dispatch({ type: GET_PERMISSIONS_REJECTED });
    }
  };
};

export const addPermission = (value) => {
  return async (dispatch) => {
    try {
      const result = await httpClient.post(`/backoffice/permissions`, value);
      dispatch({
        type: SAVE_PERMISSION_SUCCESS,
        payload: result.data.message,
      });
      dispatch(getAllPermissions());
      Swal.fire({
        text: result.data.message,
        icon: "success",
      });
    } catch (err) {
      dispatch({ type: SAVE_PERMISSION_REJECTED });
    }
  };
};

export const updatePermission = (id, value) => {
  return async (dispatch) => {
    try {
      const result = await httpClient.put(
        `/backoffice/permissions/${id}`,
        value
      );
      dispatch({
        type: SAVE_PERMISSION_SUCCESS,
        payload: result.data.message,
      });
      dispatch(getAllPermissions());
      Swal.fire({
        text: result.data.message,
        icon: "success",
      });
    } catch (err) {
      dispatch({ type: SAVE_PERMISSION_REJECTED });
    }
  };
};

export const deletePermission = (id) => {
  return async (dispatch) => {
    try {
      const result = await httpClient.delete(`/backoffice/permissions/${id}`);
      dispatch({
        type: DELETE_PERMISSION_SUCCESS,
        payload: result.data.message,
      });
      dispatch(getAllPermissions());
      Swal.fire({
        text: result.data.message,
        icon: "success",
      });
    } catch (err) {
      dispatch({ type: DELETE_PERMISSION_REJECTED });
    }
  };
};

export const deletePermissionFromRole = (roleid, permissionid) => {
  return async (dispatch) => {
    try {
      const result = await httpClient.delete(
        `/backoffice/roles/permission/${roleid}/${permissionid}`
      );
      dispatch({
        type: SAVE_ROLE_PERMISSION_SUCCESS,
        payload: result.data.message,
      });
      dispatch(getRolesById(roleid));
      Swal.fire({
        text: result.data.message,
        icon: "success",
      });
    } catch (err) {
      dispatch({ type: SAVE_ROLE_PERMISSION_REJECTED });
    }
  };
};

export const addPermissionFromRole = (role_id, value) => {
  return async (dispatch) => {
    try {
      const result = await httpClient.post(
        `/backoffice/roles/permission`,
        value
      );
      dispatch({
        type: SAVE_ROLE_PERMISSION_SUCCESS,
        payload: result.data.message,
      });
      dispatch(getRolesById(role_id));
      Swal.fire({
        text: result.data.message,
        icon: "success",
      });
    } catch (err) {
      dispatch({ type: SAVE_ROLE_PERMISSION_REJECTED });
    }
  };
};

export const getPurchaseRequestManager = () => {
  return (dispatch) => {
    dispatch({ type: LIST_USER_MANAGER_FETCH });
    return httpClient
      .get(`/backoffice/user-manager`)
      .then((result) => {
        dispatch({ type: LIST_USER_MANAGER_SUCCESS, payload: result.data });
      })
      .catch((err) => {
        dispatch({ type: LIST_USER_MANAGER_REJECTED });
      });
  };
};
